/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.21.0
 * @since 1.21.0
 */

import TableCellStatusBlock from './StatusBlock';

export {
    TableCellStatusBlock,
};
